import Verification from './Verification'
export default Verification
